import Button from "@mui/material/Button";
import {
  ThemeProvider,
  alpha,
  createTheme,
  getContrastRatio,
  useTheme as useMuiTheme,
} from "@mui/material/styles";
import * as React from "react";
import { useEffect, useState } from "react";
import { useAppTheme } from "../../../theme/useTheme";

function GeneralButton({
  variant,
  value,
  onClickEvent,
  color,
  className,
  size,
  disabled,
  title,
  startIcon,
  form,
  hidden,
  endIcon,
  style
}) {
  const { theme: appTheme, mode } = useAppTheme();
  const muiTheme = useMuiTheme();
  const [customTheme, setCustomTheme] = useState(null);
  
  useEffect(() => {
    if (color) {
      const customColorBase = color;
      const customColorMain = alpha(customColorBase, 0.7);
      
      // Create theme that respects the app's theme mode
      const themeCreated = createTheme({
        ...muiTheme,
        palette: {
          ...muiTheme.palette,
          mode: mode,
          customColor: {
            main: customColorMain,
            light: alpha(customColorBase, 0.5),
            dark: alpha(customColorBase, 0.9),
            contrastText:
              getContrastRatio(customColorMain, "#fff") > 4.5 ? "#fff" : "#111",
          },
        },
      });
      setCustomTheme(themeCreated);
    } else {
      setCustomTheme(null);
    }
  }, [color, mode, muiTheme]);

  const buttonClassName = `${className || ""} px-3 general-button ${
    typeof value !== "string" || value.length <= 7
      ? "submit_button_width"
      : ""
  }`;

  return customTheme ? (
    <ThemeProvider theme={customTheme}>
      <Button
        className={buttonClassName}
        variant={variant}
        color="customColor"
        onClick={onClickEvent}
        type={onClickEvent ? "button" : "submit"}
        size={size}
        title={title}
        disabled={disabled}
        startIcon={startIcon}
        endIcon={endIcon}
        form={form}
        hidden={hidden}
        style={style}
      >
        {value}
      </Button>
    </ThemeProvider>
  ) : (
    <Button
      className={buttonClassName}
      variant={variant}
      color="primary"
      onClick={onClickEvent}
      type={onClickEvent ? "button" : "submit"}
      size={size}
      title={title}
      disabled={disabled}
      startIcon={startIcon}
      form={form}
      hidden={hidden}
      endIcon={endIcon}
      style={style}
    >
      {value}
    </Button>
  );
}
export default GeneralButton;
